import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { UserService } from '../services/user.service';

export const unauthenticatedGuard: CanActivateFn = (route, state) => {

  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);
  const userService: UserService = inject(UserService);
  const allowAccess = authService.isAuthenticated() && userService.isAuthorized();
  
  if (allowAccess) {
    // if the user is authenticated and authorized, redirect to the root page
    // this may happen when the user has access and tries to reload the unauthenticated page
    router.navigate(['/']);
  }
  if (authService.isAuthenticated() && !userService.isAuthorized()) {
    // if the user is not authorized, redirect to unauthorized page
    // this may happen when the user is authenticated and tries to reload the unauthenticated page
    router.navigate(['/unauthorized']);
  }

  return true;
};
